"use client";

import * as LabelPrimitive from "@radix-ui/react-label";
import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";

import { cn } from "~/lib/utils";

const labelVariants = cva(
	"text-sm leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-50"
);

function Label({ ref: reference, className, ...props }: { ref?: React.Ref<React.ElementRef<typeof LabelPrimitive.Root>> } &
	React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> & VariantProps<typeof labelVariants>) {
	return (
		<LabelPrimitive.Root
			className={cn(labelVariants(), className)}
			ref={reference}
			{...props}
		/>
	);
}
Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
